let sorters = [];
/**
 * Sorts courses by last logged in date in descending order (most recent first)
 * Courses with null lastLoggedIn dates are placed at the end
 * @param {Array} courses - Array of course objects with lastLoggedIn property
 * @returns {Array} Sorted array of courses
 */
sorters.lastloggedin = (courses) =>
  courses.sort((a, b) => {
    // Filtrera null värden och placera dessa i slutet
    if (a.lastLoggedIn === null && b.lastLoggedIn === null) return 0;
    if (a.lastLoggedIn === null) return 1;
    if (b.lastLoggedIn === null) return -1;
    const dateA = new Date(a.lastLoggedIn).getTime();
    const dateB = new Date(b.lastLoggedIn).getTime();

    return dateB - dateA;
  });

sorters.title = (courses) =>
  courses.sort((a, b) => a.title.localeCompare(b.title));

sorters.createddate = (courses) => {
  return courses.sort((a, b) => {
    const dateA = new Date(a.createdDate);
    const dateB = new Date(b.createdDate);
    return dateB - dateA;
  });
};

export { sorters };
